import { useMutation } from '@tanstack/react-query';
import { confirmReserveCheckout } from './apiConfirmReserveCheckout';
import { ErrorResponse } from '../../../../shared/notification/actions';
import * as types from '../../../../store/constants';
import { PATH_RESERVE } from '../../../../store/constants';
import { OrderRequestIn, ReserveListCheckoutOut, ReserveListOrderResponse } from '../../../../store/api';
import { FormDataConfirm } from '../../../checkout/CheckoutSummary';
import { typedFailure } from '../../../checkout/utils/request-error';
import { useNotification } from '../../../../app-store/notification/useNotification';
import { useNavigate } from 'react-router-dom';

export type ReserveCheckoutMutationProps = {
    formData: FormDataConfirm;
    meta?: ReserveListCheckoutOut;
};

export const useReserveCheckout = (reserveListId: string) => {
    const { showNotificationWithInfo } = useNotification();
    const navigate = useNavigate();

    return useMutation<ReserveListOrderResponse, ErrorResponse, ReserveCheckoutMutationProps>(
        data =>
            confirmReserveCheckout(
                reserveListId,
                mapRequestBody({
                    reserveListId,
                    meta: data.meta,
                    formData: data.formData
                })
            ),
        {
            onSuccess: data => {
                navigate(`${types.PATH_CHECKOUT}/thanks`, { state: data });
            },
            onError: error =>
                typedFailure(error, `${PATH_RESERVE}/${reserveListId}`, showNotificationWithInfo, navigate)
        }
    );
};

const mapRequestBody = ({
    reserveListId,
    meta,
    formData
}: ReserveCheckoutMutationProps & { reserveListId: string }): OrderRequestIn => {
    // it is ok to force this type here,
    // because the place order button that triggers this mutation
    // is disabled when the meta request fails.
    const { totalValue, version } = meta!;

    return {
        ...formData,
        shoppingCartVersion: version,
        shoppingCartId: reserveListId,
        totalValue
    };
};
